import { render } from "./GridGrupuriAngajati.vue?vue&type=template&id=fe9011c8&ts=true"
import script from "./GridGrupuriAngajati.vue?vue&type=script&lang=ts"
export * from "./GridGrupuriAngajati.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__